import { pairWithCode } from '../api/pairing.js';
import { setDeviceToken, setDeviceMeta } from '../state/device-store.js';
import { logInfo } from '../state/log-store.js';

export async function runPairing(code) {
  const result = await pairWithCode(code);
  setDeviceToken(result.deviceToken);
  setDeviceMeta({
    deviceId: result.deviceId,
    plantId: result.device?.plantId ?? null,
    name: result.device?.name ?? null,
    pairedAt: new Date().toISOString(),
  });
  logInfo('Device paired', { deviceId: result.deviceId });
  return result;
}
